import { useState, useEffect } from 'react';
import { Navbar } from './components/navbar';
import { Sidebar } from './components/sidebar';

export interface LayoutProps {
  children: React.ReactNode;
  hideCard?: boolean;
}

/**
 * Layout con una tarjeta blanca sobre la cual se muestra todo el contenido
 */
export function Layout({ children, hideCard }: LayoutProps) {
  const [collapsed, setCollapsed] = useState(() => window.matchMedia('(max-width: 48rem)').matches);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 48rem)');
    const handle = (e: MediaQueryListEvent) => setCollapsed(e.matches);
    mq.addEventListener('change', handle);
    return () => mq.removeEventListener('change', handle);
  }, []);

  return (
    <div className="w-screen h-screen max-h-screen flex flex-col">
      <Navbar />

      <div className="flex flex-1 overflow-hidden relative">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((prev) => !prev)} />
        <div className="flex-1 overflow-hidden bg-transparent">
          {hideCard ? (
            <>{children}</>
          ) : (
            <div className="flex flex-col bg-primary-background rounded-lg max-h-full overflow-auto">
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
